import { render, staticRenderFns } from "./PersonalConfig.vue?vue&type=template&id=098fcc55&scoped=true&"
import script from "./PersonalConfig.vue?vue&type=script&lang=js&"
export * from "./PersonalConfig.vue?vue&type=script&lang=js&"
import style0 from "./PersonalConfig.vue?vue&type=style&index=0&id=098fcc55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098fcc55",
  null
  
)

export default component.exports